import { render, staticRenderFns } from "./ProductCharacteristics.vue?vue&type=template&id=4cc8f6c8&scoped=true&name=product-characteristics&"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./ProductCharacteristics.vue?vue&type=style&index=0&id=4cc8f6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8f6c8",
  null
  
)

/* custom blocks */
import block0 from "./ProductCharacteristics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports